import { MessageCircle } from "lucide-react";
import { waUrl } from "../lib/contact";
import { pushGenerateLead } from "../lib/gtmDataLayer";

export default function WhatsAppFab() {
  return (
    <a
      href={waUrl("Hi Sri Durga Foods, I have a question")}
      onClick={() => pushGenerateLead("whatsapp", { source: "fab" })}
      target="_blank"
      rel="noreferrer"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-6 h-6" strokeWidth={2} />
      <span className="absolute -top-1 -right-1 w-3 h-3 bg-brand-success rounded-full ring-2 ring-white animate-pulse" />
    </a>
  );
}
